export const arrayToMap = (array, key = 'id') =>
  array.reduce((map, item) => ({ ...map, [item[key]]: item }), {});
